var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalIncomInAMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 17,
    cy: 16.5,
    rx: 17,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 34.666 13.5003)",
    fill: "#FDCB6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.625 25.8747C36.625 25.3914 36.2332 24.9997 35.75 24.9997C35.2668 24.9997 34.875 25.3914 34.875 25.8747V30.2497C34.875 30.4817 34.9672 30.7043 35.1313 30.8684L36.8813 32.6184C37.223 32.9601 37.777 32.9601 38.1187 32.6184C38.4604 32.2767 38.4604 31.7227 38.1187 31.3809L36.625 29.8872V25.8747Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 4.87466C19.125 4.39142 18.7332 3.99966 18.25 3.99966C17.7668 3.99966 17.375 4.39142 17.375 4.87466V7.49966H14.75C11.8505 7.49966 9.5 9.85017 9.5 12.7497V33.7497C9.5 36.6492 11.8505 38.9997 14.75 38.9997H29.9439C31.6069 40.1054 33.6032 40.7497 35.75 40.7497C41.549 40.7497 46.25 36.0487 46.25 30.2497C46.25 28.1029 45.6057 26.1066 44.5 24.4435V12.7497C44.5 9.85017 42.1495 7.49966 39.25 7.49966H36.625V4.87466C36.625 4.39142 36.2332 3.99966 35.75 3.99966C35.2668 3.99966 34.875 4.39142 34.875 4.87466V7.49966H19.125V4.87466ZM25.25 30.2497C25.25 32.9389 26.261 35.392 27.9236 37.2497H14.75C12.817 37.2497 11.25 35.6827 11.25 33.7497V12.7497C11.25 10.8167 12.817 9.24966 14.75 9.24966H17.375V11.8747C17.375 12.3579 17.7668 12.7497 18.25 12.7497C18.7332 12.7497 19.125 12.3579 19.125 11.8747V9.24966H34.875V11.8747C34.875 12.3579 35.2668 12.7497 35.75 12.7497C36.2332 12.7497 36.625 12.3579 36.625 11.8747V9.24966H39.25C41.183 9.24966 42.75 10.8167 42.75 12.7497V22.4233C40.8924 20.7607 38.4392 19.7497 35.75 19.7497C29.951 19.7497 25.25 24.4507 25.25 30.2497ZM35.75 38.9997C40.5825 38.9997 44.5 35.0822 44.5 30.2497C44.5 25.4172 40.5825 21.4997 35.75 21.4997C30.9175 21.4997 27 25.4172 27 30.2497C27 35.0822 30.9175 38.9997 35.75 38.9997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIncomInAMonth);
export default __webpack_public_path__ + "static/media/total-incom-in-a-month.34795242b5b70aa71fee6d8d9f03b60d.svg";
export { ForwardRef as ReactComponent };